import MentoringList from './MentoringList.vue';

export * from './types';
export default MentoringList;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/programcard/components/main/components/list/index.ts